import { render, staticRenderFns } from "./ModerationTemplatesFilter.vue?vue&type=template&id=5d349853&"
import script from "./ModerationTemplatesFilter.vue?vue&type=script&lang=ts&"
export * from "./ModerationTemplatesFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports